module.exports = __webpack_public_path__ + "img/apng_loadingsjb.62718108.png";